import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'AccessPointIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-access-point",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12l0 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14.828 9.172a4 4 0 0 1 0 5.656"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17.657 6.343a8 8 0 0 1 0 11.314"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9.168 14.828a4 4 0 0 1 0 -5.656"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6.337 17.657a8 8 0 0 1 0 -11.314"
    }, null), _createTextVNode(" ")]);
  }
};